$(document).ready(function () {

    $('.main-navigation__item__has-submenu > a').on('click', function (e) {
        e.preventDefault();
        $('.main-navigation__subnavi').toggleClass('main-navigation__subnavi--visible');
    });
    
});